<template>
  <div class="docs-node">
    <div
      class="docs-node__row"
      :class="{ 'is-active': node.content === activeContent }"
      :style="{ paddingLeft: `${0.35 + depth * 0.85}rem` }"
    >
      <button
        v-if="node.has_children"
        type="button"
        class="docs-node__toggle"
        :aria-expanded="isExpanded ? 'true' : 'false'"
        :aria-label="isExpanded ? 'Collapse' : 'Expand'"
        @click.stop="$emit('toggle', node)"
      >
        <span aria-hidden="true">{{ isExpanded ? '▾' : '▸' }}</span>
      </button>
      <span
        v-else
        class="docs-node__spacer"
        aria-hidden="true"
      />
      <button
        type="button"
        class="docs-node__label"
        @click="onSelect"
      >
        {{ node.name }}
      </button>
    </div>

    <ul
      v-if="node.has_children && isExpanded"
      class="docs-node__children"
    >
      <li
        v-if="isLoading"
        class="docs-node__loading"
      >
        Loading…
      </li>
      <li
        v-for="child in children"
        :key="child.id"
      >
        <DocsTreeNode
          :node="child"
          :depth="depth + 1"
          :path-prefix="fullPath"
          :active-content="activeContent"
          :expanded-ids="expandedIds"
          :children-map="childrenMap"
          :loading-ids="loadingIds"
          @toggle="$emit('toggle', $event)"
          @select="forwardSelect"
        />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'DocsTreeNode',
  props: {
    node: {
      type: Object,
      required: true,
    },
    depth: {
      type: Number,
      default: 0,
    },
    pathPrefix: {
      type: Array,
      default: () => [],
    },
    activeContent: {
      type: String,
      default: '',
    },
    expandedIds: {
      type: Object,
      default: () => ({}),
    },
    childrenMap: {
      type: Object,
      default: () => ({}),
    },
    loadingIds: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['toggle', 'select'],
  computed: {
    isExpanded() {
      return Boolean(this.expandedIds[this.node.id])
    },
    isLoading() {
      return Boolean(this.loadingIds[this.node.id])
    },
    children() {
      return this.childrenMap[this.node.id] || []
    },
    fullPath() {
      return [...this.pathPrefix, this.node.content]
    },
  },
  methods: {
    onSelect() {
      this.$emit('select', this.node, this.fullPath)
      if (this.node.has_children && !this.isExpanded) {
        this.$emit('toggle', this.node)
      }
    },
    forwardSelect(node, pathSegments) {
      this.$emit('select', node, pathSegments)
    },
  },
}
</script>

<style scoped>
.docs-node__row {
  display: flex;
  align-items: center;
  gap: 0.15rem;
  border-radius: 0.4rem;
  margin-bottom: 0.15rem;
}

.docs-node__row.is-active {
  background: rgba(79, 67, 158, 0.12);
}

.docs-node__toggle,
.docs-node__label {
  border: 0;
  background: transparent;
  color: inherit;
  text-align: left;
}

.docs-node__toggle {
  width: 1.4rem;
  height: 1.4rem;
  padding: 0;
  line-height: 1;
  color: #5c5678;
  flex-shrink: 0;
}

.docs-node__spacer {
  width: 1.4rem;
  flex-shrink: 0;
}

.docs-node__label {
  flex: 1;
  padding: 0.35rem 0.4rem;
  font-size: 0.95rem;
  font-weight: 600;
  border-radius: 0.35rem;
}

.docs-node__label:hover {
  color: #4f439e;
}

.docs-node__children {
  list-style: none;
  margin: 0;
  padding: 0;
}

.docs-node__loading {
  padding: 0.25rem 0.5rem 0.25rem 2rem;
  font-size: 0.85rem;
  color: #5c5678;
}
</style>
